import React from 'react'
import {Image, Space, Typography} from "antd";
import SimpleTips from "../SimpleTips";
import {Constants} from "../../utils/ConstantsUtils";
import {ValueUtils} from "../../utils/ValueUtils";

const {Paragraph} = Typography;

const NewsListCell = ({news = {}, onClick}) => {

    return (
        <>
            <Typography style={{cursor: 'pointer'}} onClick={() => onClick && onClick(news)}>
                <Paragraph strong
                           ellipsis={{rows: 2}}
                           style={{marginBottom: 5}}>{news.title}</Paragraph>

                <Space align={'start'}>
                    {
                        news.imageUrl &&
                        <Image
                            preview={false}
                            width={100}
                            height={65}
                            style={{objectFit: 'cover'}}
                            src={news.imageUrl}
                        />
                    }
                    <Paragraph ellipsis={{rows: 3}}
                               style={{marginBottom: 5, color: '$3c3c3c'}}>{news.contentAbstract}</Paragraph>
                </Space>
            </Typography>

            <SimpleTips
                tips={[
                    Constants.newsEmotion(news.emotion),
                    ValueUtils.formatDateOrEmpty(news.publishTime, 'YYYY-MM-DD HH:mm'),
                    news.source,
                    news.author
                ]}
            />

        </>
    )
}

export default NewsListCell